import axios from "axios";
import { useQuery } from "react-query";
import { API_URL, imageUrl } from "../../../api/config";

const fetchNews = async (page: number) => {
    const { data } = await axios.get(`${API_URL}/api/v1/news?page=${page}`);
    return {
        results: data.results.map((item: any) => ({
            ...item,
            image: imageUrl(item.image),
            description: cleanDescription(item.description)
        })),
        count: typeof data.count === "number" ? data.count : data.results.length,
        next: data.next ?? null,
        previous: data.previous ?? null,
    };
};

const cleanDescription = (description: any) => {
    let cleanedString = description.replace(/<\/?[^>]+(>|$)/g, '');
    cleanedString = cleanedString.replace(/&[^;\s]+;/g, '');
    let resultArray = cleanedString.split(/\s*<br\s*\/?>\s*/).map((s: any) => s.trim()).filter(Boolean);
    return resultArray.join(' ');
};

export const useNews = ({ page = 1 }: { page?: number } = {}) => {
    const { data, isLoading, isFetching } = useQuery(
        ["news", page],
        () => fetchNews(page),
        {
            keepPreviousData: true,
            onError: (error) => {
                console.log(error);
            },
        }
    );

    return {
        news: data?.results,
        count: data?.count ?? 0,
        pageSize: data?.results?.length ?? 0,
        hasNext: !!data?.next,
        hasPrev: !!data?.previous,
        isLoading,
        isFetching,
    };
};
